module.exports = __webpack_public_path__ + "static/media/features-split-image-04.a8910f49.png";